// extracted by mini-css-extract-plugin
export default {"general":"Content_general__Y84EE","position":"Content_position__670KO","para":"Content_para__nSaJv","heading":"Content_heading__quDAQ"};